import React, { useEffect, useState } from "react";
import VendorSelect from "./VendorSelect";
import AddVendor from "./AddVendor";
import AddAssetLocation from "./AddAssetLocation";
import { Tooltip } from "@material-ui/core";
import { useStyles } from "../AssetDetails/AssetDetailsFormStyles";
import useAssetProvider from "../useAssetProvider";
import VendorSearch from "./VendorSearch";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Edit, Save, AccountCircleOutlined } from "@material-ui/icons";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import useAPIError from '../../APIError';
import NmefSpinner from "../../NmefSpinner";
import { VendorDataAPI } from '../../API/VendorDataAPI';
import { checkEditAccess } from "../../Constants/utils";
export default function Vendor({
	notSupported,
	currentVendor,
	currentLocation,
	asset,
	type,
	updateFeeVendor,
	isEdit
}) {
	const { isReadOnly, locations, onChangeAsset } = useAssetProvider();
	const [location, setLocation] = useState(currentLocation);
	const [vendorModalOpen, setVendorModalOpen] = useState(false);
	const [locationModal, setLocationModal] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [enableButton, setEnableButton] = useState(false)
	const [vendor, setVendor] = useState({});
	const { addError, setLoader } = useAPIError();
	const classes = useStyles();

	const updateAssetVendor = async () => {
		let updatedAssetData;
		if (vendor?.id === "required(will get overwritten on save)") {
			let vendorId;
			try {
				if (detectCallerType()) {
					setLoader(true);
				} else {
					setLoading(true)
				}
				if (!detectCallerType()) {
					setLoading(false)
				}
			} catch (error) {
				addError(error.message);
			} finally {
				updatedAssetData = {
					...asset,
					vendor_id: vendorId,
					vendor: vendor?.name,
					vendor_name: vendor?.name,
					is_location: false,
				};
				if (!detectCallerType()) {
					updateFeeVendor({
						id: vendorId,
						name: vendor?.name
					});
					setEnableButton(false);
				}
				setLoader(false)
			}
		} else {
			updatedAssetData = {
				...asset,
				vendor_id: vendor?.id,
				vendor: vendor?.name,
				vendor_name: vendor?.name,
				is_location: false,
			};
		};
		if (detectCallerType()) {
			onChangeAsset(updatedAssetData);
		}
	};
	const updateAssetLocation = () => {
		const newLocation = locations.filter(loc => loc.location_id === location);

		const updatedAssetData = {
			...asset,
			// location_Name: newLocation[0].name,
			// location_city: newLocation[0].city,
			location_id: newLocation[0].location_id,
			// location_state: newLocation[0].state,
			// location_street: newLocation[0].street,
			// location_zip: newLocation[0].zip,
			is_location: true,
			equip_city : newLocation[0].city,
			equip_address: newLocation[0].street,
			equip_address_id: newLocation[0].location_id,
			equip_state: newLocation[0].state,
			equip_zipcode: newLocation[0].zip,
			equip_type: newLocation[0].type,
			

			
		};
		

		onChangeAsset(updatedAssetData);
	};

	const detectCallerType = () => {
		if (!type || type !== "fee") {
			return true
		}
		return false;
	}

	const getVendorDetails = async () => {
		if (currentVendor) {
			setLoading(true)
			const vendorDetails = await VendorDataAPI.getVendor(currentVendor, '0');
			if (vendorDetails && vendorDetails.length !== 0) {
				const vendorInfo = {
					id: vendorDetails.id,
					short_id: vendorDetails.short_id ?? "",
					name: vendorDetails.name,
					address: appendAddress(vendorDetails),
					street: vendorDetails.street ?? "",
					city: vendorDetails.city ?? "",
					state: vendorDetails.state ?? "",
					zip_code: vendorDetails.zip_code ?? "",
					country: vendorDetails.country ?? "",
				};
				setVendor(vendorInfo);
				if (type === "fee" && typeof updateFeeVendor === "function") {
					updateFeeVendor(vendorInfo);
				}
			}
			setLoading(false);
		}
	}

	const appendAddress = (vendorData) => {
		let vendorAddress = "";
		if (vendorData.street) {
			vendorAddress = `${vendorData.street}`;
		}
		if (vendorData.city) {
			vendorAddress = `${vendorAddress}, ${vendorData.city}`;
		}
		if (vendorData.state) {
			vendorAddress = `${vendorAddress}, ${vendorData.state}`;
		}
		if (vendorData.zip_code) {
			vendorAddress = `${vendorAddress} - ${vendorData.zip_code}, `;
		}
		if (vendorData.address) {
			return vendorData.address;
		}

		return vendorAddress;
	}

	useEffect(() => {
		if (type && type === "fee") {
			getVendorDetails();
		}
	}, [isEdit])

	return (
		<div>
			<Grid container spacing={1} style={{ marginBottom: "0.5rem" }} justifyContent={detectCallerType() ? null : "space-between"}>
				<Grid item xs={detectCallerType() ? 3 : 4} style={{ textAlign: detectCallerType() ? "right" : "left" }}>
					<Typography variant="subtitle2" className={classes.vendorSubtitle2}>
						Vendors:
					</Typography>
					{!isReadOnly && !notSupported && checkEditAccess() && (
						<>
							<IconButton size="small" onClick={() => setVendorModalOpen(true)}>
								<AddCircleOutlineIcon />
							</IconButton>
							{vendor?.id && (!type || enableButton) && (
								<Tooltip title="Save" placement="top">
									<IconButton
										color="primary"
										onClick={() => {
											updateAssetVendor();
										}}>
										<Save />
									</IconButton>
								</Tooltip>
							)}
						</>
					)}
				</Grid>
				<Grid item xs={detectCallerType() ? 9 : 7} style={{ paddingLeft: detectCallerType() ? '0px' : '15px' }}>
					{isLoading ? <NmefSpinner /> :
						<VendorSearch
							notSupported={notSupported}
							vendor={detectCallerType() ? currentVendor : vendor}
							newAddedvendor={vendor}
							setVendor={setVendor}
							isEdit={isEdit}
							updateFeeVendor={updateFeeVendor}
							type={type}
						/>
					}
				</Grid>
			</Grid>
			{detectCallerType() && (
				<Grid container spacing={1}>
					<Grid item xs={3} style={{ textAlign: "right" }}>
						<Typography variant="subtitle2" className={classes.vendorLocationTitle}>
							Asset Location:
						</Typography>
						{!isReadOnly && !notSupported && checkEditAccess() && (
							<>
								<IconButton size="small" onClick={() => setLocationModal(true)}>
									<AddCircleOutlineIcon />
								</IconButton>
								{location !== asset?.location_id && (
									<Tooltip title="Save" placement="top">
										<IconButton
											color="primary"
											onClick={() => {
												updateAssetLocation();
											}}>
											<Save />
										</IconButton>
									</Tooltip>
								)}
							</>
						)}
					</Grid>
					<Grid item xs={9}>
						<Select
							id="location-input"
							disabled={isReadOnly || notSupported || !checkEditAccess()}
							className={classes.vendorSelectStyle}
							value={location}
							onChange={(e) => setLocation(e.target.value)}>
							{locations?.map((location) => (
								<MenuItem key={location.location_id} value={location.location_id}>
									{location.type +
										" : " +
										location.street +
										" " +
										location.city +
										" " +
										location.state +
										" " +
										location.zip}
								</MenuItem>
							))}
						</Select>
					</Grid>
				</Grid>
			)}
			<AddVendor
				vendorModalOpen={vendorModalOpen}
				setVendorModalOpen={setVendorModalOpen}
				setSaveVendor={setVendor}
				appendAddress={appendAddress}
			/>
			<AddAssetLocation
				locationModal={locationModal}
				setLocationModal={setLocationModal}
				setLocation={setLocation}
			/>
		</div>
	);
}
